/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Billing_Ends_OnInputs */

const en_settings_billing_ends_on = /** @type {(inputs: Settings_Billing_Ends_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ends on ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Ends on {date}" |
*
* @param {Settings_Billing_Ends_OnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_ends_on = /** @type {((inputs: Settings_Billing_Ends_OnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Ends_OnInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_ends_on(inputs)
});
export { settings_billing_ends_on as "settings.billing.ends_on" }